import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { DeeplinkMatch, Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { Platform } from '@ionic/angular';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeeplinkServiceService {
  constructor(
    private platform: Platform,
    private deeplinks: Deeplinks,
    private utilityService: UtilityService,
    private router: Router,
  ) {}

  /**
   * Setup deep link handler and map with mobile routes
   * DeeplinkMatch object structure
      match = {
        $route: '/2/conversation/:conversationId',
        $args: {
          conversationId: '11595',
        },
        $link: {
          path: '/2/conversation/11595',
          queryString: '',
          fragment: '',
          host: 'staging.containers.staging-mable.com.au',
          url: 'https://staging.containers.staging-mable.com.au/2/conversation/11595',
          scheme: 'https',
        },
      };
   */
  setupDeepLinks() {
    if (!this.platform.is('cordova')) {
      return;
    }

    this.deeplinks
      .route({
        // Both key and value in this URL map should be of equal length in therms of url parts otherwise it wont match.
        // Also both key and value should not be equal.
        // '/jobs/search/view/:jobId': '/jobs/search/view/jobId',
        '/conversation/:conversationId': '/conversation/conversationId',
      })
      .subscribe(
        async (match: DeeplinkMatch) => {
          if (environment.deeplinkHost === match?.$link?.host) {
            // Check if the url host matches with app's url. To cover cases like staging url is opened on prod app etc.
            // write if block and any custom requirement for each URL mapping
            // worker job rec and job alert email links
            // if (match.$route.indexOf('/jobs/search/view/jobId') !== -1) {
            //   // This link is only available for carers.
            //   this.accountService.userIs('carer')
            //     ? this.navigateAfterTimeOut(['/jobs/view/', match.$args.jobId])
            //     : this.showLinkNotAvailableAlert(match);
            // }
            // worker private job shared email link and new message email
            if (match.$route.indexOf('/conversation/conversationId') !== -1) {
              this.navigateAfterTimeOut(['/conversation/', match.$args.conversationId]);
            }
          }
        }, // if no match found, open the link in browser
        (nomatch: DeeplinkMatch) => {
          this.openLinkInBrowser(nomatch);
        },
      );
  }

  /**
   * Used to open nomatch/not allowed deep link urls in browser
   *
   * @param nomatch - Deep link match object
   */
  openLinkInBrowser(nomatch: DeeplinkMatch) {
    this.utilityService.openExternalLink(nomatch?.$link?.url);
  }

  /**
   * A wrapper around router's navigate method which navigates after a timeout.
   * Used for deep link navigation and the timeout is there to provide the app enough time to wake and land on home page.
   *
   * @param commands - url commands
   * @param extras - Navigation extras
   */
  navigateAfterTimeOut(commands: any[], extras?: NavigationExtras) {
    setTimeout(() => this.router.navigate(commands, extras), 800);
  }

  // /**
  //  * Show alert when the deep link is not meant for the logged in user. e.g. Client accessing carer's link
  //  *
  //  * @param match - Deep link match object
  //  */
  // async showLinkNotAvailableAlert(match) {
  //   (
  //     await this.alertCtrl.create({
  //       message:
  //         'The link you are trying to open is not available for you. Please log in using different user or open in browser.',
  //       buttons: [
  //         { text: 'Ok' },
  //         {
  //           text: 'Open in browser',
  //           handler: () => {
  //             this.openLinkInBrowser(match);
  //           },
  //         },
  //       ],
  //     })
  //   ).present();
  // }
}
